// extracted by mini-css-extract-plugin
module.exports = {"container":"SaleRow_container__3IFIE","active":"SaleRow_active__38TK5","label":"SaleRow_label__1QK89","input":"SaleRow_input__2QyNq","unit":"SaleRow_unit__3XIko"};